import api from "../API/apiConfig";

export const leadsByYear = async () => {
    return await api.get(`leads/by-year`);
}

export const leadsByStage = async (period) => {
    return await api.get(`leads/by-stage?period=${period}`);
}

export const leadsByCampaign = async (period) => {
    return await api.get(`leads/by-campaign?period=${period}`);
}

export const leadRecent = async (period) => {
    return await api.get(`leads/recent-created?period=${period}`);
}

export const getTypePipeline = async (type) => {
    return await api.get(`/pipelines/${type}`);
  };

  export const opporByYear = async () => {
    return await api.get(`opportunities/by-year`);
}

export const opporByStage = async (period) => {
    return await api.get(`opportunities/by-stage?period=${period}`);
}

export const opporRecent = async () => {
    return await api.get(`opportunities/by-status`);
}